import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getConfig } from "@/lib/api";
import { PLANS } from "@/data/content";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [item, setItem] = useState(null); // { planId, qty }
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [config, setConfig] = useState({ payments_enabled: false, razorpay_key_id: null });

  useEffect(() => {
    getConfig()
      .then(setConfig)
      .catch(() => {});
  }, []);

  const plan = useMemo(
    () => (item ? PLANS.find((p) => p.id === item.planId) : null),
    [item]
  );

  const total = plan ? plan.price * item.qty : 0;
  const count = item ? item.qty : 0;

  const addToCart = (planId, qty = 1) => {
    setItem((prev) => {
      if (prev && prev.planId === planId) return { planId, qty: prev.qty + qty };
      return { planId, qty };
    });
    setCartOpen(true);
  };

  const setQty = (qty) => {
    if (qty <= 0) return setItem(null);
    setItem((prev) => (prev ? { ...prev, qty } : prev));
  };

  const clearCart = () => setItem(null);

  const value = {
    item,
    plan,
    total,
    count,
    cartOpen,
    setCartOpen,
    checkoutOpen,
    setCheckoutOpen,
    config,
    addToCart,
    setQty,
    clearCart,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
